import React, { useState } from "react";
import { Button, Form, InputGroup, Modal, Spinner } from "react-bootstrap";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import NumberFormat from "react-number-format";
import { getInputClasses } from "@utils/get-input-classes";

const AmountLetterSufficientModal = ({
  show,
  onHide,
  onSubmit,
  title = "¿El Monto de tu Carta de Autorización cubre el Gasto de la Hospitalización?",
  submitButtonText = "Continuar"
}) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [showAlert, setShowAlert] = useState(false);

  const validationSchema = Yup.object().shape({
    amountAuthorizationLetter: Yup.string()
      .required("El campo es requerido"),
    hospitalizationExpenseAmount: Yup.string()
      .required("El campo es requerido"),
    requiresAdditionalTabLetter: Yup.string()
      .required("El campo es requerido"),
  });

  const initialValues = {
    amountAuthorizationLetter: "",
    hospitalizationExpenseAmount: "",
    requiresAdditionalTabLetter: ""
  };

  const handleOptionChange = (value) => {
    setSelectedOption(value);
    setShowAlert(false);
  };

  const handleAdditionalTabChange = (e, handleChange) => {
    handleChange(e);
    setShowAlert(e.target.value === 'si');
  };

  const handleSubmit = async (values, formikBag) => {
    await onSubmit(values, selectedOption, formikBag);
  };

  const handleContinueWithoutForm = () => {
    onSubmit({}, selectedOption);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <Form.Group className="d-flex align-items-center">
          <Form.Check
            type="radio"
            id="radio-yes"
            label="Sí"
            name="amountLetterSufficient"
            value="Y"
            checked={selectedOption === 'Y'}
            onChange={(e) => handleOptionChange(e.target.value)}
          />
          <Form.Check
            className="ml-5"
            type="radio"
            id="radio-no"
            label="No"
            name="amountLetterSufficient"
            value="N"
            checked={selectedOption === 'N'}
            onChange={(e) => handleOptionChange(e.target.value)}
          />
        </Form.Group>

        {selectedOption === 'Y' && (
          <Formik
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            enableReinitialize={true}
            initialValues={initialValues}
          >
            {({ values, errors, touched, handleChange, handleSubmit, isSubmitting }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="amountAuthorizationLetter">
                  <Form.Label>Captura importe carta autorización</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>$</InputGroup.Text>
                    <NumberFormat
                      fixedDecimalScale={true}
                      decimalScale={2}
                      value={values.amountAuthorizationLetter}
                      onChange={handleChange}
                      name="amountAuthorizationLetter"
                      thousandSeparator={true}
                      className={`form-control ${getInputClasses(
                        touched,
                        errors,
                        "amountAuthorizationLetter"
                      )}`}
                    />
                  </InputGroup>
                  <ErrorMessage name="amountAuthorizationLetter">
                    {msg => (
                      <Form.Control.Feedback type="invalid">
                        {msg}
                      </Form.Control.Feedback>
                    )}
                  </ErrorMessage>
                </Form.Group>

                <Form.Group controlId="hospitalizationExpenseAmount">
                  <Form.Label>Captura importe gasto hospitalización</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>$</InputGroup.Text>
                    <NumberFormat
                      fixedDecimalScale={true}
                      decimalScale={2}
                      value={values.hospitalizationExpenseAmount}
                      onChange={handleChange}
                      name="hospitalizationExpenseAmount"
                      thousandSeparator={true}
                      className={`form-control ${getInputClasses(
                        touched,
                        errors,
                        "hospitalizationExpenseAmount"
                      )}`}
                    />
                  </InputGroup>
                  <ErrorMessage name="hospitalizationExpenseAmount">
                    {msg => (
                      <Form.Control.Feedback type="invalid">
                        {msg}
                      </Form.Control.Feedback>
                    )}
                  </ErrorMessage>
                </Form.Group>

                <Form.Group>
                  <Form.Label>¿Requieres alguna carta de tabulacion adicional?</Form.Label>
                  <div className={`${getInputClasses(touched, errors, "requiresAdditionalTabLetter")}`}>
                    <Form.Check
                      inline
                      type="radio"
                      id="radio-yesR"
                      label="Sí"
                      name="requiresAdditionalTabLetter"
                      value="si"
                      checked={values.requiresAdditionalTabLetter === 'si'}
                      onChange={(e) => handleAdditionalTabChange(e, handleChange)}
                    />
                    <Form.Check
                      inline
                      className="ml-5"
                      type="radio"
                      id="radio-noR"
                      label="No"
                      name="requiresAdditionalTabLetter"
                      value="no"
                      checked={values.requiresAdditionalTabLetter === 'no'}
                      onChange={(e) => handleAdditionalTabChange(e, handleChange)}
                    />
                  </div>
                  <ErrorMessage name="requiresAdditionalTabLetter">
                    {msg => (
                      <Form.Control.Feedback type="invalid">
                        {msg}
                      </Form.Control.Feedback>
                    )}
                  </ErrorMessage>
                </Form.Group>

                {!showAlert && (
                  <Button variant="primary" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <Spinner as="span" animation="border" variant="dark" size="sm" />}
                    {submitButtonText}
                  </Button>
                )}

                {showAlert && (
                  <span style={{ color: 'red', fontWeight: 'bold' }}>
                    NOTA: Favor de capturar los datos del médico a tabular en el apartado de "HONORARIOS MEDICOS".
                  </span>
                )}
              </Form>
            )}
          </Formik>
        )}
      </Modal.Body>

      <Modal.Footer>
        {selectedOption === 'N' && (
          <Button variant="primary" onClick={handleContinueWithoutForm}>
            {submitButtonText}
          </Button>
        )}
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AmountLetterSufficientModal; 